module.exports = __webpack_public_path__ + "img/sc-4p-2023-2.1cbec396.png";